import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobangloretaxiservice() {



const cardData = {
  keyword: " Pune to Bangalore Taxi Service ",

"headingDescription": "SRS Cab Service offers Pune to Bangalore Taxi Service, providing a comfortable, safe, and long-distance travel solution for families, professionals, and corporate travelers. Our well-maintained vehicles, experienced drivers, and timely pickups ensure a smooth and hassle-free journey from Pune to Bangalore. Ideal for business trips, family travel, and intercity journeys, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a reliable and convenient travel experience.",
"topPlaces": [
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace is a historic landmark known for its grand architecture and royal heritage. Travelers using SRS Cab Service from Pune often visit this palace to explore its interiors and beautiful surroundings."
  },
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden is a famous garden featuring rare plants and a glasshouse. Visitors using SRS Cab Service often enjoy peaceful walks and scenic views here."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park is a large green space in the heart of Bangalore. Travelers using SRS Cab Service often relax here and enjoy nature amidst the city."
  },
  {
    "title": "ISKCON Temple Bangalore",
    "description": "ISKCON Temple Bangalore is a well-known spiritual center dedicated to Lord Krishna. Visitors using SRS Cab Service often visit for prayer and peaceful surroundings."
  },
  {
    "title": "Bannerghatta National Park",
    "description": "Bannerghatta National Park is a popular wildlife destination near Bangalore. Travelers using SRS Cab Service often explore this park for safaris and nature experiences."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is an iconic government building known for its impressive architecture. Visitors using SRS Cab Service often admire this landmark from outside."
  },
  {
    "title": "Ulsoor Lake",
    "description": "Ulsoor Lake is a scenic lake ideal for boating and relaxation. Travelers using SRS Cab Service often visit to enjoy calm surroundings and water views."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is a popular shopping destination in Bangalore. Visitors using SRS Cab Service often explore this area for shopping, food, and local experiences."
  },
  {
    "title": "Wonderla Amusement Park",
    "description": "Wonderla is a famous amusement park with thrilling rides and water attractions. Travelers using SRS Cab Service often include this destination for fun and entertainment."
  },
  {
    "title": "Nandi Hills",
    "description": "Nandi Hills is a scenic hill station near Bangalore known for sunrise views. Visitors using SRS Cab Service often plan a trip here for nature and photography."
  }
],



services: [
{
name: "Pune to Bangalore Taxi Service",
description: "Pune to Bangalore taxi service offers reliable long-distance travel for business and leisure trips. Customers can book taxis for comfortable journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily from Pune to Bangalore with taxi services."
},
{
name: "Pune to Bangalore Taxi Booking",
description: "Pune to Bangalore taxi booking provides quick and easy reservation options. Customers can book taxis online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily for Bangalore travel."
},
{
name: "Pune to Bangalore Car Rental",
description: "Pune to Bangalore car rental offers flexible travel options for long-distance trips. Customers can rent cars for family and business travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Rent cars easily from Pune."
},
{
name: "Pune to Bangalore Taxi Rates",
description: "Pune to Bangalore taxi rates provide clear pricing details for travelers. Customers can compare rates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent rates."
},
{
name: "Pune to Bangalore Cab Charges",
description: "Pune to Bangalore cab charges offer detailed pricing for travel planning. Customers can check charges before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent charges."
},
{
name: "Pune to Bangalore Cab Pricing",
description: "Pune to Bangalore cab pricing provides a complete cost breakdown for trips. Customers can compare pricing before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with transparent pricing."
},
{
name: "Pune to Bangalore Private Car Hire",
description: "Pune to Bangalore private car hire offers personalized travel for families and corporate trips. Customers can hire vehicles for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with private car hire services."
},
{
name: "Pune to Bangalore Cab Cost",
description: "Pune to Bangalore cab cost provides estimated pricing for travelers. Customers can check trip cost before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab cost services."
},
{
name: "Pune to Bangalore Taxi Service Charges",
description: "Pune to Bangalore taxi service charges offer clear pricing for transportation. Customers can check charges before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent charges."
},
{
name: "Pune to Bangalore Travel Cabs",
description: "Pune to Bangalore travel cabs provide convenient options for long-distance journeys. Customers can book cabs for comfortable trips. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with travel cab services."
},
{
name: "Pune to Bangalore Taxi",
description: "Pune to Bangalore taxi offers reliable transportation for intercity travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Bangalore Cab",
description: "Pune to Bangalore cab provides convenient travel for long-distance trips. Customers can book cabs for family and business travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Bangalore Cab Booking",
description: "Pune to Bangalore cab booking offers quick reservation options for travelers. Customers can book cabs online or via apps. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily from Pune."
},
{
name: "Pune to Bangalore Cab Service",
description: "Pune to Bangalore cab service offers dependable transportation for long-distance travel. Customers can book cabs for flexible trips. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Bangalore Taxi Fare",
description: "Pune to Bangalore taxi fare provides detailed pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with taxi fare services."
},
{
name: "Taxi from Pune to Bangalore",
description: "Taxi from Pune to Bangalore provides convenient travel for intercity journeys. Customers can book taxis for business and leisure trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Bangalore Innova Cab",
description: "Pune to Bangalore Innova cab offers premium SUV travel for long journeys. Customers can enjoy spacious seating and comfort. Professional drivers ensure safe travel. Ideal for family trips. Transparent pricing ensures value for money. Travel comfortably with Innova cab services."
},
{
name: "Pune to Bangalore Tempo Traveller on Rent",
description: "Pune to Bangalore tempo traveller on rent offers group travel solutions for long-distance trips. Customers can book spacious vehicles for family and corporate trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Pune to Bangalore Sedan Car on Rent",
description: "Pune to Bangalore sedan car on rent provides affordable travel for individuals and small groups. Customers can book vehicles for budget-friendly journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan car services."
},
{
name: "Pune to Bangalore Ertiga Car on Rent",
description: "Pune to Bangalore Ertiga car on rent offers comfortable 7-seater travel for families. Customers can book vehicles for long-distance trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga services."
},
{
name: "Pune to Bangalore Swift Car on Rent",
description: "Pune to Bangalore swift car on rent offers economical travel for budget-friendly trips. Customers can book vehicles for long-distance journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with swift car services."
},
{
name: "Pune to Bangalore Mini Bus on Rent",
description: "Pune to Bangalore mini bus on rent provides group travel solutions for large families and corporate trips. Customers can book buses for comfortable journeys. Professional drivers ensure safe travel. Spacious seating enhances experience. Flexible booking options are available. Travel easily with mini bus services."
},
{
name: "Pune to Bangalore Cab Service",
description: "Pune to Bangalore cab service provides reliable transportation for long-distance travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
}
],

tableData: [
["Pune to Bangalore Taxi Service","Pune to Bangalore Taxi Booking"],
["Pune to Bangalore Car Rental","Pune to Bangalore Taxi Rates"],
["Pune to Bangalore Cab Charges","Pune to Bangalore Cab Pricing"],
["Pune to Bangalore Private Car Hire","Pune to Bangalore Cab Cost"],
["Pune to Bangalore Taxi Service Charges","Pune to Bangalore Travel Cabs"],
["Pune to Bangalore Taxi","Pune to Bangalore Cab"],
["Pune to Bangalore Cab Booking","Pune to Bangalore Cab Service"],
["Pune to Bangalore Taxi Fare","Taxi from Pune to Bangalore"],
["Pune to Bangalore Innova Cab","Pune to Bangalore Tempo Traveller on Rent"],
["Pune to Bangalore Sedan Car on Rent","Pune to Bangalore Ertiga Car on Rent"],
["Pune to Bangalore Swift Car on Rent","Pune to Bangalore Mini Bus on Rent"],
["Pune to Bangalore Cab Service","Pune to Bangalore Taxi Service"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "SRS Cab Service provides expert drivers experienced in Pune to Bangalore routes, ensuring safe highway driving, proper rest planning, and smooth intercity travel."
  },
  {
    WhyChooseheading: "Affordable Pune to Bangalore Taxi Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune to Bangalore taxi services with transparent pricing. Customers receive complete fare details including tolls, state taxes, and driver allowance with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Taxi Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Bangalore taxi bookings, making it convenient for business travel, family trips, and urgent long-distance journeys."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles for Long Travel",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles designed for long-distance comfort, ensuring a relaxed journey from Pune to Bangalore."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We provide one-way taxi service, round-trip bookings, and customized travel plans for Pune to Bangalore journeys based on customer requirements."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for individual, family, and corporate travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We offer convenient pickup from homes, hotels, offices, and Pune Airport across all major areas including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Intercity Taxi Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Bangalore taxi bookings due to punctual service, professional drivers, and reliable vehicles for long-distance travel."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Bangalore taxi service?", answer: "Yes, SRS Cab Service offers reliable taxi services from Pune to Bangalore for long-distance travel." },
  { question: "How far is Bangalore from Pune?", answer: "The distance between Pune and Bangalore is approximately 840 km and the journey takes around 14 to 16 hours depending on route and traffic." },
  { question: "Is Pune to Bangalore taxi service available 24 hours?", answer: "Yes, our taxi service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for Pune to Bangalore travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way taxi from Pune to Bangalore?", answer: "Yes, we provide both one-way and round-trip taxi services." },
  { question: "Do you provide multi-day travel options?", answer: "Yes, we offer customized multi-day travel plans for Pune to Bangalore journeys." },
  { question: "Are vehicles suitable for long-distance travel?", answer: "Yes, all vehicles are well-maintained and suitable for long-distance journeys." },
  { question: "Can I book the taxi online?", answer: "Yes, you can easily book Pune to Bangalore taxi service online or via phone." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Deshpande",
    feedback:
      "Booked SRS Cab Service for Pune to Bangalore trip. Very smooth and comfortable long journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Riya Kulkarni",
    feedback:
      "Excellent Pune to Bangalore taxi service. Reliable and perfect for long-distance travel.",
    rating: 5
  }
];




























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bangalore Taxi Service | SRS Cab",
  "description": "Book Pune to Bangalore taxi services with SRS Cab. One-way, round trips, and private car hire available. Travel comfortably with Innova, Sedan, or Tempo Traveller. Affordable taxi service with 24x7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2150"
  }
};










  return (
    <div>
      <Helmet>
  <title>Pune to Bangalore Taxi Service | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="SRS Cab offers Pune to Bangalore taxi services including one-way, round trips, and private car hire. Travel comfortably with Innova, Sedan, or Tempo Traveller. Affordable, reliable, and 24x7 online booking available." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/46.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetobangloretaxiservice;